import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=9c20abda"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=9c20abda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports